import { FunctionComponent } from 'react'

import { Container } from '../components/Container'

import { VisualizationComponentProps } from '../types'

import { getMaximumGap } from '../utils/getMaximumGap'

import { RowVisualizationItem } from './RowVisualizationItem'

export const Row: FunctionComponent<VisualizationComponentProps> = ({
  items,
  benchmark,
  isLegendVisible,
  isScoreBy10,
  legend,
  isGaps,
}) => (
  <Container
    benchmark={benchmark}
    isLegendVisible={isLegendVisible}
    legend={legend}
    items={items}
    isVertical
  >
    {items.map(item => (
      <RowVisualizationItem
        key={item.label}
        item={item}
        isScoreBy10={isScoreBy10}
        isGaps={isGaps}
        maxGap={isGaps ? getMaximumGap(items) : undefined}
      />
    ))}
  </Container>
)
